import { render, staticRenderFns } from "./resetVerify.vue?vue&type=template&id=7552fe4d&scoped=true&"
import script from "./resetVerify.vue?vue&type=script&lang=js&"
export * from "./resetVerify.vue?vue&type=script&lang=js&"
import style0 from "./resetVerify.vue?vue&type=style&index=0&id=7552fe4d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7552fe4d",
  null
  
)

export default component.exports